import axios from "axios";

import { MOBI_API_URL } from "../shared/constants";

/**
 * Mobi.Core — upload e classificação de capturas (TV-2). O sessionId da sala É o
 * token_regulacao, então a própria URL autentica (mesmo nível do fluxo legado).
 * Substitui a romaria PUT na PAR → serviço de mídia → apiToken.cfm?act=saveFotoDB:
 * um POST cria a linha completa (hash, antifraude, histórico, OCI, thumb) e o
 * classificar define o tipo via IA e dispara a análise.
 */
const mobiHost = axios.create({ baseURL: MOBI_API_URL });

export interface CapturaCriada {
  idFoto: number;
  arquivoFoto: string;
  thumbFoto: string;
  fraude: number;
  urlConteudo: string | null;
  urlThumb: string | null;
}

export async function uploadCaptura(sessionId: string, blob: Blob): Promise<CapturaCriada> {
  const formData = new FormData();
  formData.append("file", blob, "captura.jpg");

  const response = await mobiHost.post<CapturaCriada>(
    `/api/v1/regulacoes/${sessionId}/capturas`,
    formData
  );
  return response.data;
}

export interface ClassificacaoCaptura {
  classificada: boolean;
  classe: string | null;
  confianca: number | null;
  tipoFoto: string | null;
  tipoDefinido: boolean;
  analiseDisparada: boolean;
  motivo: string | null;
}

export async function classificarCaptura(sessionId: string, idFoto: number): Promise<ClassificacaoCaptura> {
  const response = await mobiHost.post<ClassificacaoCaptura>(
    `/api/v1/regulacoes/${sessionId}/fotos/${idFoto}/classificar`
  );
  return response.data;
}
